import { useCopyTourMutation } from '@carboncopyco/data';
import type { Tour } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { CopyAssetModal } from '../../../CopyAssetModal';

interface CopyTourModalWithFoldersProps {
  organizationId: string;
  tour: Tour;
  goToCopiedTour?: (
    tourId: number,
    workspaceId: string,
    folderId: string
  ) => void;
}

export const CopyTourModalWithFolders = NiceModal.create(
  ({ organizationId, tour, goToCopiedTour }: CopyTourModalWithFoldersProps) => {
    const [copyTour, { isLoading: isLoadingCopyTour }] = useCopyTourMutation();
    const modal = useModal();
    const tourFolderId = String(tour.folderId);
    const tourWorkspaceId = String(tour.workspaceId);

    return (
      <CopyAssetModal
        isLoading={isLoadingCopyTour}
        close={modal.remove}
        origin={{
          id: tourFolderId,
          entity: tourFolderId === '0' ? 'workspace' : 'folder',
          workspaceId: tourWorkspaceId,
        }}
        onSubmit={({ assetName, folderId, workspaceId }) => {
          copyTour({
            organizationId,
            id: Number(tour.id),
            targetWorkspaceId: workspaceId,
            folderId: folderId,
            tourName: assetName,
          })
            .unwrap()
            .then(({ id, workspaceId, folderId }) => {
              goToCopiedTour?.(id, workspaceId, folderId);
              notify.success('Tour was copied successfully');
            })
            .catch(() => {
              notify.error('Failed to copy tour');
            })
            .finally(modal.remove);
        }}
      />
    );
  }
);
